/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
import { addLocaleData } from 'react-intl';
import { DEFAULT_LOCALE } from './constants/locale'; // eslint-disable-line
import { DEFAULT_CONFIGURATOR_TYPE } from './constants/configuratorType'; // eslint-disable-line

import enLocaleData from 'react-intl/locale-data/en';
import deLocaleData from 'react-intl/locale-data/de';
import nlLocaleData from 'react-intl/locale-data/nl';
import frLocaleData from 'react-intl/locale-data/fr';
import beLocaleData from 'react-intl/locale-data/be';
import trLocaleData from 'react-intl/locale-data/tr';
import ukLocaleData from 'react-intl/locale-data/uk';
import itLocaleData from 'react-intl/locale-data/it';
import daLocaleData from 'react-intl/locale-data/da';
import huLocaleData from 'react-intl/locale-data/hu';
import skLocaleData from 'react-intl/locale-data/sk';
import csLocaleData from 'react-intl/locale-data/cs';
import ruLocaleData from 'react-intl/locale-data/ru';
import esLocaleData from 'react-intl/locale-data/es';
import plLocaleData from 'react-intl/locale-data/pl';
import cyLocaleData from 'react-intl/locale-data/cy';
import egLocaleData from 'react-intl/locale-data/en';
import arLocaleData from 'react-intl/locale-data/ar';
import lvLocaleData from 'react-intl/locale-data/lv';
import etLocaleData from 'react-intl/locale-data/et';
import ltLocaleData from 'react-intl/locale-data/lt';
import noLocaleData from 'react-intl/locale-data/no';
import roLocaleData from 'react-intl/locale-data/ro';
import ptLocaleData from 'react-intl/locale-data/pt';
import hrLocaleData from 'react-intl/locale-data/hr';
import bgLocaleData from 'react-intl/locale-data/bg';


export const locale = LANG ? LANG : DEFAULT_LOCALE;
export const configuratorType = CONFIGURATOR_TYPE ? CONFIGURATOR_TYPE : DEFAULT_CONFIGURATOR_TYPE;
export const version = VERSION ? VERSION : '';
//import enTranslationMessages from './translations/shower.en_gb.json';
const enTranslationMessages = require(`./translations/${configuratorType}.${locale}.json`);

addLocaleData(enLocaleData);
addLocaleData(deLocaleData);
addLocaleData(nlLocaleData);
addLocaleData(frLocaleData);
addLocaleData(beLocaleData);
addLocaleData(trLocaleData); 
addLocaleData(ukLocaleData);
addLocaleData(daLocaleData);
addLocaleData(huLocaleData);
addLocaleData(itLocaleData);
addLocaleData(skLocaleData);
addLocaleData(csLocaleData);
addLocaleData(ruLocaleData);
addLocaleData(esLocaleData);
addLocaleData(plLocaleData);
addLocaleData(cyLocaleData);
addLocaleData(egLocaleData);
addLocaleData(arLocaleData);
addLocaleData(lvLocaleData);
addLocaleData(etLocaleData);
addLocaleData(ltLocaleData);
addLocaleData(noLocaleData);
addLocaleData(roLocaleData);
addLocaleData(ptLocaleData);
addLocaleData(hrLocaleData);
addLocaleData(bgLocaleData);


export const localeFormatted = locale.replace(/_(.*)/gm,function(x){return x.toUpperCase();});
export const lang = locale.substr(0,2);

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages = locale !== DEFAULT_LOCALE.substr(0,2) ? formatTranslationMessages(DEFAULT_LOCALE.substr(0,2), enTranslationMessages) : {};
  const formattedMessages = {};
  const messageKeys = Object.keys(messages);
  for (const messageKey of messageKeys) {
    if (locale === DEFAULT_LOCALE) {
      formattedMessages[messageKey] = messages[messageKey];
    } else {
      formattedMessages[messageKey] = messages[messageKey] || defaultFormattedMessages[messageKey];
    }
  }

  return formattedMessages;
};

export const translationMessages = {
  current: formatTranslationMessages(lang, require(`./translations/${configuratorType}.${locale}.json`)),
  en: formatTranslationMessages('en', enTranslationMessages)
};

 


// WEBPACK FOOTER //
// ./src/i18n.js